import React from 'react';
import { ShieldCheckIcon, CheckIcon, SpinnerIcon, ArrowPathIcon } from '../../../../components/Icons';

interface AdminVisibilityMatrixHeaderProps {
  isLoadingProps: boolean;
  isSaving: boolean;
  onRefresh: () => void;
  onSave: () => void;
}

export const AdminVisibilityMatrixHeader: React.FC<AdminVisibilityMatrixHeaderProps> = ({
  isLoadingProps,
  isSaving,
  onRefresh,
  onSave,
}) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
      <div>
        <h2 className="text-xl font-black text-gray-900 uppercase tracking-tight flex items-center gap-3">
          <ShieldCheckIcon className="w-7 h-7 text-[#0073b7]" />
          Matriz de Visibilidad por Fuente
        </h2>
        <p className="text-gray-500 text-sm font-medium">
          Define qué fuentes de inventario puede ver cada rol de usuario.
        </p>
      </div>
      <div className="flex items-center gap-3">
        <button
          onClick={onRefresh}
          disabled={isLoadingProps}
          className="p-2 bg-gray-100 text-gray-600 rounded-xl hover:bg-gray-200 transition-all disabled:opacity-50"
          title="Actualizar lista de fuentes"
        >
          <ArrowPathIcon className={`w-5 h-5 ${isLoadingProps ? 'animate-spin' : ''}`} />
        </button>
        <button
          onClick={onSave}
          disabled={isSaving || isLoadingProps}
          className="flex items-center gap-2 px-6 py-2.5 bg-[#0073b7] text-white rounded-xl font-black text-xs uppercase tracking-widest hover:bg-sky-700 transition-all shadow-lg shadow-sky-100 disabled:opacity-50"
        >
          {isSaving ? <SpinnerIcon className="w-4 h-4" /> : <CheckIcon className="w-4 h-4" />}
          Guardar Cambios
        </button>
      </div>
    </div>
  );
};
